import React from 'react';
import './Appointment.scss';
import SectionTitle from '../SectionTitle/SectionTitle';

const Appointment = () => {

    const mapLink = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4198.362259347335!2d20.52329277751324!3d50.51827188247703!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4717bfae2f2ac1ef%3A0xe7ac7c78312ad9f2!2sZ%C5%82ota%20Centrum%20Zdrowia!5e1!3m2!1sen!2spl!4v1740333105765!5m2!1sen!2spl'

    return (
        <section className='section-common appointment-section section-m'  data-aos="fade-up" data-aos-duration="1000">
            <div className="container">
            <div className="row section-p">
                    <div className="col-lg-6 col-sm-6 ">
                        <SectionTitle title="Jak do nas dojechać?" subTitle="Kontakt"/>
                    </div>
                    <div className="col-lg-6 col-sm-6">
                    </div>
                </div>
                <div className="row align-items-center section-p">
                    <div className="col-lg-12">
                        <div className="google-map">
                            <iframe title='map' src={mapLink}></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Appointment;